import { Role } from "../../models/Role";
import DocumentList from "../genericcrud/DocumentList";
const RoleMaster = () => {
  return (
    <>{<DocumentList documentMeta={Role} isModel={true}/>}</>
  );
};

export default RoleMaster;
